import { useState } from 'react';
import { Button, Divider, Popover } from 'antd';
import { GearIcon, SignOutIcon } from '@phosphor-icons/react';
import type { IERPUser } from '@admin-panel/types';
import SettingsModal from '../SettingsModal';
import UserAvatar from '@admin-panel/components/lib/avatar/UserAvatar';
import { isMobile } from 'react-device-detect';

type Props = {
  user?: IERPUser;
  onLogout: () => void;
  placement?: 'rightTop' | 'bottomRight';
  trigger?: Array<'hover' | 'click'>;
};

const AvatarPopover = ({ user, onLogout, placement = 'rightTop', trigger = ['hover'] }: Props) => {
  const [settingsOpen, setSettingsOpen] = useState(false);
  return (
    <>
      <Popover
        placement={placement}
        trigger={trigger}
        arrow={false}
        styles={{
          body: {
            padding: 0,
          },
        }}
        content={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              width: 200,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '8px 12px',
              }}
            >
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 600 }}>{user?.name ?? 'User'}</div>
                {user?.email && (
                  <div style={{ color: 'rgba(0,0,0,0.65)', fontSize: 12 }}>{user.email}</div>
                )}
              </div>
            </div>
            <Divider style={{ margin: 0 }} />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                padding: '8px',
              }}
            >
              <Button
                type="text"
                icon={<GearIcon />}
                onClick={() => setSettingsOpen(true)}
                style={{
                  justifyContent: 'flex-start',
                  padding: '4px 8px',
                  height: 32,
                  width: '100%',
                }}
              >
                Settings
              </Button>
              <Button
                type="text"
                icon={<SignOutIcon />}
                onClick={onLogout}
                style={{
                  justifyContent: 'flex-start',
                  padding: '4px 8px',
                  height: 32,
                  width: '100%',
                }}
              >
                Logout
              </Button>
            </div>
          </div>
        }
      >
        <UserAvatar
          name={user?.name ?? ''}
          email={user?.email}
          size={isMobile ? 28 : 32}
          shape={isMobile ? 'round' : 'square'}
        />
      </Popover>
      <SettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} user={user} />
    </>
  );
};

export default AvatarPopover;
